// extracted by mini-css-extract-plugin
module.exports = {"logout_btn":"user-profile_logout_btn__xZcIV"};